module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.ea653965.mp3";